import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  computed,
  inject,
  ViewEncapsulation
} from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { LoaderComponent, LoaderService } from '@partners/kernel';
import { ShellStore } from '@partners/state';
import { ROUTE_ANIMATION } from '@partners/ui';
import { ApplicationFooterComponent } from '../application-footer/application-footer.component';
import { ApplicationHeaderComponent } from '../application-header/application-header.component';
import { ApplicationProgressComponent } from '../application-progress/application-progress.component';
import { DebuggerComponent } from '../debugger/debugger.component';

@Component({
  selector: 'application-view',
  standalone: true,
  imports: [
    RouterModule,
    DebuggerComponent,
    ApplicationHeaderComponent,
    ApplicationProgressComponent,
    ApplicationFooterComponent,
    LoaderComponent
  ],
  template: `
    <application-header></application-header>
    @if(isProgressRendered$$()){
    <application-progress class="application-progress"></application-progress>
    }

    <div class="application-route" [@routeAnimation]="routeState(rootOutlet)">
      <router-outlet id="root-outlet" #rootOutlet="outlet"></router-outlet>
    </div>

    <application-footer class="application-footer"></application-footer>
    @if(showLoader$$()){
    <application-loader></application-loader>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [ROUTE_ANIMATION]
})
export class ApplicationViewComponent {
  private _shellStore = inject(ShellStore);
  private _loaderService = inject(LoaderService);
  private _changeDetector = inject(ChangeDetectorRef);

  readonly showLoader$$ = computed<boolean>(() => this._loaderService.loaderState$$()?.toggle);

  // showLoader$$ = signal(true);

  isProgressRendered$$ = computed<boolean>(() => {
    this._changeDetector.markForCheck();
    const { isProgressRendered } = this._shellStore.viewSettings$$();
    // console.log(`is progress rendered ${isProgressRendered}`);
    return isProgressRendered;
  });

  routeState(outlet: RouterOutlet) {
    return outlet.isActivated ? outlet.activatedRoute : '';
  }
}
